/* eslint-disable */
/* tslint:disable */
export type ILocaleKeys = {
    app: {
      widget: {
        /* app.widget.welcome */
        /* Hello */
        welcome: () => string; 
      }; 
      settings: {
        defaults: {
          /* app.settings.defaults.greetingsPretext */
          /* to */
          greetingsPretext: () => string; 
        }; 
        tabs: {
          /* app.settings.tabs.design */
          /* Design */
          design: () => string; 
          /* app.settings.tabs.main */
          /* Main */
          main: () => string; 
        }; 
        /* app.settings.label */
        /* Configure Widget */
        label: () => string; 
      }; 
    }; 
    checkoutSlot: {
      paymentDetails: {
        enterStoreCredit: {
          error: {
            /* checkoutSlot.paymentDetails.enterStoreCredit.error.general */
            /* We’re experiencing a technical issue on our end. Refresh the page and try again. */
            general: () => string; 
            /* checkoutSlot.paymentDetails.enterStoreCredit.error.serviceDown */
            /* Sorry, we can't accept credit right now because of a technical issue. Please continue without your credit or try again later. */
            serviceDown: () => string; 
            /* checkoutSlot.paymentDetails.enterStoreCredit.error.disabled */
            /* Your credit can't be applied right now. Please contact us for more details.  */
            disabled: () => string; 
            /* checkoutSlot.paymentDetails.enterStoreCredit.error.noBalance */
            /* You don’t have any available credit. */
            noBalance: () => string; 
            /* checkoutSlot.paymentDetails.enterStoreCredit.error.wrongCurrency */
            /* The credit currency doesn't match the currency of the site. Change your cart's currency and try again. */
            wrongCurrency: () => string; 
            /* checkoutSlot.paymentDetails.enterStoreCredit.error.expired */
            /* Your credit has expired. */
            expired: () => string; 
          }; 
        }; 
      }; 
      redeemStoreCredit: {
        codeAlreadyInUse: {
          /* checkoutSlot.redeemStoreCredit.codeAlreadyInUse.errorMessage */
          /* This code is already in use. */
          errorMessage: () => string; 
        }; 
        /* checkoutSlot.redeemStoreCredit.cta */
        /* Apply */
        cta: () => string; 
        upToOrderTotal: {
          /* checkoutSlot.redeemStoreCredit.upToOrderTotal.warningMessage */
          /* The applied credit amount can be up to your order total. */
          warningMessage: () => string; 
        }; 
        title: {
          /* checkoutSlot.redeemStoreCredit.title.new */
          /* Use your {{amount}} credit */
          new: (data: Record<'amount', unknown>) => string; 
          /* checkoutSlot.redeemStoreCredit.title */
          /* Use your {amount} credit */
          $value: () => string; 
        }; 
        creditEmpty: {
          /* checkoutSlot.redeemStoreCredit.creditEmpty.errorMessage */
          /* You don’t have any available credit. */
          errorMessage: () => string; 
        }; 
      }; 
    }; 
    creditWidget: {
      memberCredit: {
        label: {
          /* creditWidget.memberCredit.label.0 */
          /* You have {amount} in credit */
          '0': () => string; 
          /* creditWidget.memberCredit.label */
          /* You have {{amount}} in credit */
          $value: (data: Record<'amount', unknown>) => string; 
        }; 
      }; 
      editWidget: {
        gfpp: {
          /* creditWidget.editWidget.gfpp.label */
          /* Edit Credit Widget */
          label: () => string; 
        }; 
      }; 
      layersPanel: {
        /* creditWidget.layersPanel.label */
        /* Credit Balance Widget */
        label: () => string; 
      }; 
    }; 
  };
import { pathgen } from 'object-path-generator';
import React from 'react';

const createProxyImpl = <R extends string>(
  t = (...[k]: unknown[]) => k as R
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
) =>
  pathgen<R>(undefined, (path: string, ...options: any[]) => {
    const finalPath = path.split('.$value')[0];
    return t(finalPath, ...options);
  }) as unknown;

export function LocaleKeys<R extends string>(t: (...args: unknown[]) => R) {
  return createProxyImpl(t) as ILocaleKeys;
}

const LocaleKeysContext = React.createContext({} as ILocaleKeys);
export const LocaleKeysProvider: React.FC<{ translateFn?: (...args: unknown[]) => string; localeKeys?: ILocaleKeys; children?: React.ReactNode }> = ({ translateFn, localeKeys, children }) => {
    if (!translateFn && !localeKeys) { throw new Error('Either translateFn or localeKeys must be provided') }
    const value = (typeof translateFn === 'function' ? LocaleKeys(translateFn) : localeKeys) as ILocaleKeys
    return <LocaleKeysContext.Provider value={value}>{children}</LocaleKeysContext.Provider>;
  };
export const useLocaleKeys = () => React.useContext(LocaleKeysContext);
